import { Routes } from '@angular/router';
import { HeatmapPageComponent } from './pages/heatmap/heatmap-page.component';
import { SettingsPageComponent } from './pages/settings/settings-page.component';
import { UserComponent } from './pages/god_section/user/user.component';
import { roleGuard } from './auth/role.guard';
import { INTERNAL_ALLOWED_ROLES } from './auth/roles';
import { environment } from './environment/environment';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'heatmap' },
  { path: 'heatmap', component: HeatmapPageComponent },
  { path: 'settings', component: SettingsPageComponent },
  {
    path: 'user-management',
    component: UserComponent,
    ...(environment.roleGuardEnabled ? { canActivate: [roleGuard(INTERNAL_ALLOWED_ROLES)] } : {})
  },
  {
    path: 'license-management',
    loadComponent: () => import('./pages/god_section/license/license.component').then(m => m.LicenseComponent),
    ...(environment.roleGuardEnabled ? { canActivate: [roleGuard(INTERNAL_ALLOWED_ROLES)] } : {})
  },
  {
    path: 'antenna-management',
    loadComponent: () => import('./pages/god_section/antenna/antenna.component').then(m => m.AntennaComponent),
    ...(environment.roleGuardEnabled ? { canActivate: [roleGuard(INTERNAL_ALLOWED_ROLES)] } : {})
  },
  {
    path: 'bom-component-management',
    loadComponent: () => import('./pages/god_section/bom-component/bom-component.component').then(m => m.BomComponentComponent),
    ...(environment.roleGuardEnabled ? { canActivate: [roleGuard(INTERNAL_ALLOWED_ROLES)] } : {})
  },
  {
    path: 'obstacle-management',
    loadComponent: () => import('./pages/god_section/obstacle/obstacle.component').then(m => m.ObstacleComponent),
    ...(environment.roleGuardEnabled ? { canActivate: [roleGuard(INTERNAL_ALLOWED_ROLES)] } : {})
  },
  {
    path: 'ipd-management',
    loadComponent: () => import('./pages/god_section/ipd/ipd.component').then(m => m.IPDComponent),
    ...(environment.roleGuardEnabled ? { canActivate: [roleGuard(INTERNAL_ALLOWED_ROLES)] } : {})
  },
  {
    path: 'channel-management',
    loadComponent: () => import('./pages/god_section/channel/channel.component').then(m => m.ChannelComponent),
    ...(environment.roleGuardEnabled ? { canActivate: [roleGuard(INTERNAL_ALLOWED_ROLES)] } : {})
  },
  {
    path: 'amplifier-management',
    loadComponent: () => import('./pages/god_section/amplifier/amplifier.component').then(m => m.AmplifierComponent),
    ...(environment.roleGuardEnabled ? { canActivate: [roleGuard(INTERNAL_ALLOWED_ROLES)] } : {})
  },
  {
    path: 'floorplan-management',
    loadComponent: () => import('./pages/floorplan/floorplan.component').then(m => m.FloorPlanComponent)
  },
  {
    path: 'project-management',
    loadComponent: () => import('./pages/project/project.component').then(m => m.ProjectComponent)
  }
];
